// extracted by mini-css-extract-plugin
export default {"header":"GoogleConsole_header__8r7Yu","container":"GoogleConsole_container__iCkRl"};